<template>
  <ClientOnly>
    <template v-if="(props.data?.tooltip || props.data?.tooltip === null) || props.data?.helpersData">
      <div
        v-if="isDesktop"
        ref="tooltipRef"
        v-tooltip.bottom.isDarkMode="{ value: props.data?.tooltip, escape: false, showDelay: props.data?.enableTooltip === false ? 10000000000 : true }"
        :style="props.data?.parentStyle"
        :class="[props.data?.helpersData?.items
                   ? 'cursor-pointer'
                   : props.data?.tooltip && props.data?.tooltip !== null
                     ? 'cursor-help'
                     : 'cursor-default',
                 props.data?.parentClasses]"
        @click="() => {
          if (props.data?.helpersData?.items) {
            drawerOptions.helpers = {
              typeId: 'helpers',
              componentId: 'FormsGroupHelpers',
              header: props.data?.helpersData.header,
              items: props.data?.helpersData.items,
              returnData: () => { }
            }
          }
        }"
      >
        <slot name="content">
          <div
            v-if="props.data?.content || props.data?.content === null"
            v-html="props.data?.content"
          ></div>
          <div
            v-else-if="props.data?.icon"
            class="icon flex relative top-[2px]"
            :class="props.data?.icon"
          ></div>
          <div
            v-else
            class="icon icon-circle-info-sparkle flex relative top-[2px]"
          ></div>
        </slot>
      </div>
    
      <div
        v-else
        ref="tooltipRef"
        v-tooltip.bottom.focus.isDarkMode="{ value: props.data?.tooltip, escape: false, hideDelay: 0, showDelay: props.data?.enableTooltip === false ? 10000000000 : true}"
        tabindex="1"
        :style="props.data?.parentStyle"
        :class="[props.data?.helpersData?.items
                   ? 'cursor-pointer'
                   : props.data?.tooltip && props.data?.tooltip !== null
                     ? 'cursor-help'
                     : 'cursor-default',
                 props.data?.parentClasses]"
        @click="() => {
          if (props.data?.helpersData?.items) {
            drawerOptions.helpers = {
              typeId: 'helpers',
              componentId: 'FormsGroupHelpers',
              header: props.data?.helpersData.header,
              items: props.data?.helpersData.items,
              returnData: () => { }
            }
          }
        }"
      >
        <slot name="content">
          <div
            v-if="props.data?.content || props.data?.content === null"
            v-html="props.data?.content"
          ></div>
          <div
            v-else-if="props.data?.icon"
            class="icon flex relative top-[2px]"
            :class="props.data?.icon"
          ></div>
          <div
            v-else
            class="icon icon-circle-info-sparkle flex relative top-[2px]"
          ></div>
        </slot>
      </div>
    </template>
    <template v-else>
      <slot name="content"></slot>
    </template>
  </ClientOnly>
</template>

<script setup>
const { drawerOptions } = usePopups()
const { isDesktop } = useDevice()

const tooltipRef = ref(false)

/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})

/**
* Hover
*/
watch(useElementHover(tooltipRef), (hovered) => {
  if (hovered) {
    setTimeout(() => {
      document.querySelectorAll('[data-pc-name="tooltip"]').forEach((tooltip) => {
        const left = tooltip.style?.left?.replace('px', '') * 1
        const fromRight = left + tooltip.offsetWidth

        if (left < 0) {
          tooltip.style.left = '0px'
        }

        if ((window.innerWidth - fromRight - 50) < 0) { 
          tooltip.style.left = `${left + (window.innerWidth - fromRight - 80)}px`
        }
      })
    }, 10)
  }
})
</script>